import type { ReactNode } from "react";

import type { WPResourceCollection } from "../../../../models/WPContentBlock";

export async function fetchResourceCollection(
  model: WPResourceCollection,
): Promise<ReactNode> {
  const { ResourceCollection } = await import(
    "../../../components/blocks/ResourceCollection/ResourceCollection"
  );

  return <ResourceCollection model={model} />;
}
